import React from 'react';
import { FaTimes } from 'react-icons/fa';
import css from './ConfirmationModal.module.css';

interface ConfirmationModalProps {
  title: string;
  message: string;
  confirmText?: string;
  cancelText?: string;
  onConfirm: () => void;
  onCancel: () => void;
  icon?: React.ReactNode;
}

const ConfirmationModal: React.FC<ConfirmationModalProps> = ({
  title,
  message,
  confirmText = 'Confirm',
  cancelText = 'Cancel',
  onConfirm,
  onCancel,
  icon
}) => {
  return (
    <div className={css.modalOverlay}>
      <div className={css.modal}>
        <button className={css.closeButton} onClick={onCancel}>
          <FaTimes />
        </button>
        
        <div className={css.modalHeader}>
          {icon && <span className={css.deleteIcon}>{icon}</span>}
          <h2>{title}</h2>
        </div>
        
        <div className={css.modalContent}>
          <p>{message}</p>
        </div>
        
        <div className={css.modalFooter}>
          <button 
            className={css.cancelButton} 
            onClick={onCancel}
          >
            {cancelText}
          </button>
          <button 
            className={css.confirmButton} 
            onClick={onConfirm}
          >
            {confirmText}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmationModal; 